module.exports = __webpack_public_path__ + "img/hr-water-green-inner-corner.f33e0914.png";